import axios from "axios";
import { TYPES } from "./bailiff_document.type";
import { onSnapshot, query, where, doc } from "firebase/firestore";
//func
import { getRefs } from "../ref";
// import { getStorage, ref, uploadBytesResumable } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getApiFunctions } from "store/bailiff/api";
import { getApp } from "firebase/app";
import { getStorage, ref, uploadBytesResumable } from "firebase/storage";

//
const app = getApp();
const auth = getAuth();
const storageBailiff = getStorage(app);

// ========= firebase function =========//
const STATUS = ["ready for download", "downloaded"]; // , "deleting"
//snap all provider
const allBailiffDocumentSub = [];
export const snapBailiffDocument = (callback) => (dispatch) => {
  setBailiffDocumentAllSuccess(dispatch, null);
  const cRef = getRefs().bailiff;
  const auth = getAuth(app);
  const uid = auth?.currentUser?.uid;
  const c1 = where("status", "in", STATUS);
  const c2 = where("client", "==", uid);
  const qRef = query(cRef, c1, c2);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      console.log({ data });
      setBailiffDocumentAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allBailiffDocumentSub.push(unsub);
};

export const unSnapBailiffDocument = () => (dispatch) => {
  allBailiffDocumentSub.forEach((subscriber) => {
    subscriber();
  });
  allBailiffDocumentSub.length = 0;
};

//snap all provider
const allBailiffDetailSub = [];
export const snapBailiffDetail =
  ({ id }, callback) =>
  (dispatch) => {
    console.log({ id });
    setBailiffDocumentDetailSuccess(dispatch, null);
    const cRef = getRefs().bailiff;
    const uid = auth?.currentUser?.uid;
    const c0 = where("id", "==", id);
    const c1 = where("client", "==", uid);
    const qRef = query(cRef, c0, c1);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs?.map((doc) => doc?.data());
        const detail = data?.length > 0 ? data[0] : null;
        setBailiffDocumentDetailSuccess(dispatch, detail);
        if (callback) {
          callback();
        }
      }
    });
    allBailiffDetailSub.push(unsub);
  };

export const unSnapBailiffDetail = () => (dispatch) => {
  allBailiffDetailSub.forEach((subscriber) => {
    subscriber();
  });
  allBailiffDetailSub.length = 0;
};

// ========= cloud function =========//
export const getBailiffRaw =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().master.viewDetailSegments;
    const options = { id };
    functions(options)
      .then((res) => {
        console.log({ res });
        setBailiffDocumentRawSuccess(dispatch, res);
        callback && callback({ status: 200 });
      })
      .catch(
        (err) =>
          callback &&
          callback({ status: 500, data: err?.message || "Please try again!" }),
      );
  };

// ========= storage function =========//
export const uploadBase64 =
  ({ file, fileName }, callback) =>
  async (dispatch) => {
    // reset before snap.
    setBailiffDocumentPerProccessSuccess(dispatch, 0);
    setBailiffDocumentProccessCompleteSuccess(dispatch, false);

    const contentType = file?.type;
    const rawFileName = fileName.split(".")[0];

    // get signed url.
    const responseUrl = await getSignedUrl({
      fileName: rawFileName,
      contentType,
    });
    const signedUrl = responseUrl?.data?.url;
    console.log({ signedUrl });
    if (!signedUrl) {
      callback &&
        callback({ status: 500, data: "Invalid Request! Please try again!" });
      return;
    }

    try {
      const response = await axios.put(signedUrl, file, {
        headers: {
          "Content-Type": file.type || "audio/mpeg",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1),
          );
          setBailiffDocumentPerProccessSuccess(
            dispatch,
            Math.round(percentCompleted),
          );
        },
      });

      console.log({ response });
      callback && callback({ status: 200 });
      setBailiffDocumentProccessCompleteSuccess(dispatch, true);
    } catch (error) {
      console.error("Upload failed", error);
    }
  };

// // lấy signed url.
const getSignedUrl = async ({ fileName, contentType }) => {
  const functions = getApiFunctions().client.clientUploadAudio;
  const options = { fileName, contentType };
  return functions(options)
    .then((signedUrl) => {
      console.log({ signedUrl });
      return signedUrl;
    })
    .catch((err) => {
      console.log({ err });
      return null;
    });
};

// export const uploadBase64 =
//   ({ file, fileName }, callback) =>
//   async (dispatch) => {
//     // reset before snap.
//     setBailiffDocumentPerProccessSuccess(dispatch, 0);
//     setBailiffDocumentProccessCompleteSuccess(dispatch, false);

//     //
//     const cRef = getRefs().job;
//     const folder = doc(cRef).id;
//     const uid = auth?.currentUser?.uid;
//     console.log({ folder });

//     // cấu trúc path.
//     const path = `client/${uid}/bailiff/${folder}/${fileName}`;
//     // console.log({ path, string });
//     const storeRef = ref(storageBailiff, path);
//     const task = uploadBytesResumable(storeRef, file);

//     // run task.
//     task.on(
//       "state_changed",
//       (snapshot) => {
//         // Tính toán phần trăm hoàn thành
//         const percent = snapshot.bytesTransferred / snapshot.totalBytes;
//         setBailiffDocumentPerProccessSuccess(dispatch, Math.round(percent));
//       },
//       (error) => {
//         console.error("Upload failed:", error);
//         callback &&
//           callback({
//             status: 500,
//             data: error?.message || "Please try again!",
//           });
//       },
//       async () => {
//         // hoàn tất
//         callback && callback({ status: 200 });
//         setBailiffDocumentProccessCompleteSuccess(dispatch, true);
//         // setBailiffDocumentDepositJobIdSuccess(dispatch, folder); // //snap job id.
//         console.log("Success upload! ");
//       },
//     );
//   };

// cấu trúc cũ.
// """"""""""""""""""
// cấu trúc path.
// const path = `client/${uid}/bailiff/${folder}/${fileName}_${timestamp}.mp3`;
// const blob = await fetch(string).then((res) => res.blob()); // đổi string thành blob để tải percent.
// // console.log({ path, string });
// const storeRef = ref(storageBailiff, path);
// const task = uploadBytesResumable(storeRef, blob);

// // run task.
// task.on(
//   "state_changed",
//   (snapshot) => {
//     // Tính toán phần trăm hoàn thành
//     const percent = snapshot.bytesTransferred / snapshot.totalBytes;
//     setBailiffDocumentPerProccessSuccess(dispatch, Math.round(percent));
//   },
//   (error) => {
//     console.error("Upload failed:", error);
//     callback &&
//       callback({
//         status: 500,
//         data: error?.message || "Please try again!",
//       });
//   },
//   async () => {
//     // hoàn tất
//     callback && callback({ status: 200 });
//     setBailiffDocumentProccessCompleteSuccess(dispatch, true);
//     setBailiffDocumentDepositJobIdSuccess(dispatch, folder); // //snap job id.
//     console.log("Success upload! ");
//   }
// );
// """"""""""""""""""

// ========= local function =========//
export const setBailiffDocumentAll = (data, callback) => (dispatch) => {
  setBailiffDocumentAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentOpenAdd = (data, callback) => (dispatch) => {
  setBailiffDocumentOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentOpenEdit = (data, callback) => (dispatch) => {
  setBailiffDocumentOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentSelected = (data, callback) => (dispatch) => {
  setBailiffDocumentSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentSearch = (data, callback) => (dispatch) => {
  setBailiffDocumentSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentRaw = (data, callback) => (dispatch) => {
  setBailiffDocumentRawSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentSort = (data, callback) => (dispatch) => {
  setBailiffDocumentSortSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentOpenPay = (data, callback) => (dispatch) => {
  setBailiffDocumentOpenPaySuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentOpenUpload = (data, callback) => (dispatch) => {
  setBailiffDocumentOpenUploadSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentStep = (data, callback) => (dispatch) => {
  setBailiffDocumentStepSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};
export const setBailiffDocumentPerUpload = (data, callback) => (dispatch) => {
  setBailiffDocumentPerUploadSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentAudio = (data, callback) => (dispatch) => {
  setBailiffDocumentAudioSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDocumentAudioDuration =
  (data, callback) => (dispatch) => {
    setBailiffDocumentAudioDurationSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const setBailiffDocumentUploadComplete =
  (data, callback) => (dispatch) => {
    setBailiffDocumentUploadCompleteSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const uploadStep = () => (dispatch) => {
  setBailiffDocumentStepSuccess(dispatch, 0);
};

export const previewStep = () => (dispatch) => {
  setBailiffDocumentStepSuccess(dispatch, 1);
};

export const finishStep = () => (dispatch) => {
  setBailiffDocumentStepSuccess(dispatch, 2);
};

// reset variable.
export const resetFields = () => (dispatch) => {
  setBailiffDocumentStepSuccess(dispatch, 0);
  setBailiffDocumentPerProccessSuccess(dispatch, 0);
  setBailiffDocumentProccessCompleteSuccess(dispatch, false);
  setBailiffDocumentDepositJobIdSuccess(dispatch, null);
  setBailiffDocumentUploadComplete(dispatch, false);
  setBailiffDocumentAudioSuccess(dispatch, { file: null, fileName: "" });
  setBailiffDocumentAudioDurationSuccess(dispatch, 0);
};

export const cancelFields = () => (dispatch) => {
  setBailiffDocumentStepSuccess(dispatch, 0);
  setBailiffDocumentPerProccessSuccess(dispatch, 0);
  setBailiffDocumentProccessCompleteSuccess(dispatch, false);
  setBailiffDocumentDepositJobIdSuccess(dispatch, null);
  setBailiffDocumentUploadComplete(dispatch, false);
  setBailiffDocumentAudioSuccess(dispatch, { file: null, fileName: "" });
  setBailiffDocumentAudioDurationSuccess(dispatch, 0);
};

// ========= dispatch =========//

const setBailiffDocumentAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_ALL,
    payload: data,
  });
};

const setBailiffDocumentOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_OPEN_ADD,
    payload: data,
  });
};

const setBailiffDocumentOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_OPEN_EDIT,
    payload: data,
  });
};

const setBailiffDocumentSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_SELECTED,
    payload: data,
  });
};

const setBailiffDocumentSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_SEARCH,
    payload: data,
  });
};

const setBailiffDocumentDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_DETAIL,
    payload: data,
  });
};

const setBailiffDocumentRawSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_RAW,
    payload: data,
  });
};

const setBailiffDocumentSortSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_SORT,
    payload: data,
  });
};

const setBailiffDocumentOpenPaySuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_OPEN_PAY,
    payload: data,
  });
};

const setBailiffDocumentOpenUploadSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_OPEN_UPLOAD,
    payload: data,
  });
};

const setBailiffDocumentStepSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_STEP,
    payload: data,
  });
};

const setBailiffDocumentPerUploadSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_PER_UPLOAD,
    payload: data,
  });
};

const setBailiffDocumentPerProccessSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_PER_PROGRESS,
    payload: data,
  });
};

const setBailiffDocumentAudioSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_AUDIO,
    payload: data,
  });
};

const setBailiffDocumentAudioDurationSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_AUDIO_DURATION,
    payload: data,
  });
};

const setBailiffDocumentUploadCompleteSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_UPLOAD_COMPLETE,
    payload: data,
  });
};

const setBailiffDocumentProccessCompleteSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_PROCCESS_COMPLETE,
    payload: data,
  });
};

const setBailiffDocumentDepositJobIdSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DOCUMENT_DEPOSIT_JOB_ID,
    payload: data,
  });
};
